import { Tarification, Devis, Contract, TypePromo } from 'src/app/core/models/form-state.model';
import { VyVTarifCreateResponse } from 'src/app/api/models/vyVTarifCreateResponse';
import { VyVDevisCreateResponse } from 'src/app/api/models/vyVDevisCreateResponse';
import { VyVContractCreateResponse } from 'src/app/api/models/vyVContractCreateResponse';

export class ApiResponseBodyUtils {
  static ExtractTarifResponseBody(response: VyVTarifCreateResponse): Tarification {
    const TypePromo = (response.Promotion?.TypePromo ?? undefined) as TypePromo | undefined;
    return {
      TarifId: response.TarifId,
      Promotion: {
        ...response.Promotion,
        TypePromo
      },
      Formules: response.Formules.map(f => ({
        NomFormule: f.NomFormule,
        PrimeMensuelle: f.PrimeMensuelle,
        PrimeAnnuelle: f.PrimeAnnuelle,
        PrimesOptions: {
          ObjetsValeur: {
            Valeur10000: f.PrimesOptions.ObjetsValeur.Valeur10000,
            Valeur15000: f.PrimesOptions.ObjetsValeur.Valeur15000
          },
          ProtectionNomades: f.PrimesOptions.ProtectionNomades,
          ProtectionJuridique: f.PrimesOptions.ProtectionJuridique,
          ProtectionVelos: f.PrimesOptions.ProtectionVelos,
          AssuranceScolaire: {
            // Les propriétés Numeo, Nom, Prenom et DateNaissance ne sont pas retournées par l'API
            Numero: 0,
            Nom: '',
            Prenom: '',
            DateNaissance: '',
            Enfant1: f.PrimesOptions.AssuranceScolaire.Enfant1,
            Enfant2: f.PrimesOptions.AssuranceScolaire.Enfant2,
            Enfant3: f.PrimesOptions.AssuranceScolaire.Enfant3,
            Enfant4Plus: f.PrimesOptions.AssuranceScolaire.Enfant4Plus
          }
        }
      }))
    };
  }

  static ExtractDevisResponseBody(response: VyVDevisCreateResponse): Devis {
    return {
      NumeroDevis: response.NumeroDevis,
      RefDocumentDevis: response.RefDocumentDevis,
      RefDocumentFIC: response.RefDocumentFIC,
      RefDocumentCG: response.RefDocumentCG,
      RefDocumentInfo: response.RefDocumentInfo,
      GDAPositif: response.GDAPositif,
      PPEPositif: response.PPEPositif
    };
  }

  static ExtractContractResponseBody(response: VyVContractCreateResponse): Contract {
    return {
      EstSansEffet: false,
      EstSigne: false,
      NumeroContrat: response.NumeroContrat,
      RefDocumentCP: response.RefDocumentCP,
      RefDocumentFIC: response.RefDocumentFIC,
      RefDocumentMandatSEPA: response.RefDocumentMandatSEPA,
      RefDocumentAttestation: response.RefDocumentAttestation,
      RefDocumentCG: response.RefDocumentCG,
      RefDocumentsSI: response.RefDocumentsSI
    };
  }
}
